import { SET_SHOWPOPUP } from "../actionTypes";

export function setShowPopup(input) {
  return {
    type: SET_SHOWPOPUP,
    payload: input,
  };
}
